@if (active) {
    <div class="request-status" role="status" aria-live="polite" aria-atomic="true" [attr.aria-label]="message">
        <img src="assets/images/logo_sise.png" alt="" width="64" height="40">
        <span>{{ message }}</span>
    </div>
}
